import React from 'react';
import { useStyletron } from 'baseui';
import { Button } from 'baseui/button';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import {
	DateRangeInput,
	EMPTY_ARRAY,
	InputRenderer,
	MAX_DATE,
	MAX_DATE_OBJECT,
	MIN_DATE,
	MIN_DATE_OBJECT,
	RenderConfig
} from 'commons-ui';

const validationSchema = yup.object().shape({
	fromToDate: yup
		.array()
		.test({
			message: 'Incomplete date range',
			test: (value: any) => value.length === 2
		})
		.test({
			message: `"from" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value[0] >= MIN_DATE_OBJECT && value[0] <= MAX_DATE_OBJECT
		})
		.test({
			message: `"To" date must be in a range of ${MIN_DATE} to ${MAX_DATE}`,
			test: (value: any) => value[1] >= MIN_DATE_OBJECT && value[1] <= MAX_DATE_OBJECT
		})
});

const filterDefaults = {
	fromToDate: EMPTY_ARRAY
};

const renderConfig = new RenderConfig().setName('fromToDate').setRenderer(DateRangeInput).setRenderProps({
	placeholder: 'from-To date',
	noWrapper: true,
	size: 'compact'
});

interface DateRangeFilterProps {
	onSubmit: (data: any) => void;
}

const DateRangeFilter = ({ onSubmit }: DateRangeFilterProps) => {
	const {
		watch,
		control,
		handleSubmit,
		formState: { errors }
	} = useForm({
		defaultValues: filterDefaults,
		resolver: yupResolver(validationSchema || yup.object())
	});
	const [css] = useStyletron();

	return (
		<form className={css({ display: 'flex', gap: '30px' })} onSubmit={handleSubmit(onSubmit)}>
			<div className={css({ width: '350px' })}>
				<InputRenderer errors={errors} field={renderConfig} control={control} watch={watch} />
			</div>
			<Button kind='primary' size='compact'>
				Apply Daterange Filter
			</Button>
		</form>
	);
};

export default DateRangeFilter;
